import { render, staticRenderFns } from "./ApiHealthBanner.vue?vue&type=template&id=948f321c&scoped=true&"
import script from "./ApiHealthBanner.vue?vue&type=script&lang=js&"
export * from "./ApiHealthBanner.vue?vue&type=script&lang=js&"
import style0 from "./ApiHealthBanner.vue?vue&type=style&index=0&id=948f321c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f321c",
  null
  
)

export default component.exports